import { Outlet, useParams, Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { Flex, Container, ScrollArea, Box } from "@radix-ui/themes";
import { AutomationConfigurationSidebar } from "@/features/automation-configuration/parts/AutomationConfigurationSidebar";
import { AutomationConfigurationHeader } from "@/features/automation-configuration/parts/AutomationConfigurationHeader";
import { useSimulatorConfiguration } from "@/features/automation-configuration/useSimulatorConfiguration";
import { useGetChannelConfigurationViews } from "@/features/automation-configuration/AutomationConfiguration.config";
import styles from "@/features/automation-configuration/AutomationConfiguration.module.scss";

export function AutomationConfiguration() {
  const { simulatorId } = useParams();
  const { pathname } = useLocation();
  const { loadingSimulator } = useSimulatorConfiguration(simulatorId);
  const { channel, views } = useGetChannelConfigurationViews();

  const isResourcesPage = useMemo(
    () => pathname.includes("/resources"),
    [pathname]
  );

  const containerSize = useMemo(() => {
    if (isResourcesPage) return "4";
    return channel === "autonomous_ticket_event" ? "2" : "4";
  }, [channel, isResourcesPage]);

  if (loadingSimulator) {
    return <></>;
  }

  if (views == null || channel == null || views.length === 0) {
    return <Navigate to={`/`} />;
  }

  return (
    <Flex
      flexGrow={"1"}
      direction={"column"}
      className={styles.AutomationConfiguration}
    >
      <AutomationConfigurationHeader channel={channel} />
      {channel === "knowledge_hub" ? (
        <Outlet />
      ) : (
        <Flex flexGrow={"1"} overflow={"hidden"}>
          <AutomationConfigurationSidebar channel={channel} views={views} />

          <ScrollArea>
            <Container
              size={containerSize}
              pt={"12px"}
              pb={"40px"}
              minWidth={"600px"}
            >
              <Box className={styles.Content}>
                <Outlet />
              </Box>
            </Container>
          </ScrollArea>
        </Flex>
      )}
    </Flex>
  );
}
